import { forwardRef } from 'react';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';
import { FplAppContextMenu } from './FplAppContextMenu';
import { ModalAppContextMenu } from './ModalAppContextMenu';
import type { AppContextMenuProps } from './AppContextMenu.types';

export const AppContextMenu = forwardRef<HTMLDivElement, AppContextMenuProps>(function AppContextMenu(props, ref) {
  const isFplMigrationEnabled = useFplMigrationFlag();

  if (isFplMigrationEnabled) {
    return <FplAppContextMenu {...props} />;
  }

  const { colorTheme: _colorTheme, ...modalProps } = props;
  return <ModalAppContextMenu {...modalProps} ref={ref} />;
});

export type { AppContextMenuProps };
